import { useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
// import { setLogin } from "../redux/features/auth/actions";

const useRefreshToken = () => {
    const baseUrl = useSelector((state)=> state.counter.baseUrl)
    // const auth = useSelector((state) => state.auth);
    // const dispatch = useDispatch()

  useEffect(() => {
    const refreshToken = async () => {
      try {
        const response = await axios.post(`${baseUrl}home/azure/refresh/`, {
          refresh_token: '',
          session_id:''
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials:true
        });
      //  dispatch(setLogin({...auth,recentStatus:response.status}))
        sessionStorage.setItem(
          "expires_at",
          Date.now() + response.data.expires_in * 1000
        );
      } catch (error) {
        console.error("Failed to refresh token:", error);
      }
    };
    // Refresh the token every 5 minutes
    const interval = setInterval(refreshToken, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);
};

export default useRefreshToken;
